import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const Page = styled.article`
  padding: ${tokens.spacer.x3} ${tokens.spacer.x4} 0;
`;

export const PageSection = styled.div`
  width: 720px;
  margin-top: ${tokens.spacer.x6pt5};
`;

export const InfoText = styled.div`
  margin-bottom: ${tokens.spacer.x4};
  color: ${tokens.ALIAS_TEXT_COLORS.text_light};

  a {
    color: ${tokens.ALIAS_COLORS.link};
  }
`;
